import React, { useEffect, useState } from "react";
import { CiLocationArrow1 } from "react-icons/ci";
import { GoHome } from "react-icons/go";
import { MdOutlineLocationOn, MdOutlineWorkOutline } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

export default function SaveAddressAs({ formData, setFormData }) {
  const [isOther, setIsOther] = useState(false);
  useEffect(() => {
    if (!["venue", "work", "home"].includes(formData.addressLabel)) {
      setIsOther(true);
    }
  }, [formData.addressLabel]);
  return (
    <>
      <div className=" text-[.875rem] mt-4 mb-2 text-[grey]  ">
        Save address as
      </div>
      {isOther ? (
        <div className="flex text-[.825rem] items-end my-1 font-[500] ">
          <div
            style={{
              backgroundColor: "#F0F5FE",
              borderColor: "#a3c1fe",
              color: "#2136d4",
              fontWeight: 500,
            }}
            className="border cursor-pointer border-gray-200 px-2 mr-2 flex items-center gap-[2px] py-1 rounded-md "
          >
            <MdOutlineLocationOn />
            Other
          </div>
          <input
            type="text"
            value={formData.addressLabel}
            onChange={(e) =>
              setFormData((p) => ({
                ...p,
                addressLabel: e.target.value,
              }))
            }
            className="px-2 border-b rounded-none pb-2 w-full text-[.825rem] "
            placeholder="Type here"
          />
          <RxCross2
            onClick={() => {
              setFormData((p) => ({
                ...p,
                addressLabel: "home",
              }));
              setIsOther(false);
            }}
            className="text-[1.5rem] pb-2 cursor-pointer border-b"
          />
        </div>
      ) : (
        <div className="flex text-[.825rem] mt-1 font-[400]  gap-4">
          <div
            onClick={() => {
              setFormData((p) => ({
                ...p,
                addressLabel: "home",
              }));
            }}
            style={
              formData.addressLabel === "home"
                ? {
                    backgroundColor: "#F0F5FE",
                    borderColor: "#a3c1fe",
                    color: "#2136d4",
                    fontWeight: 500,
                  }
                : { opacity: 0.6 }
            }
            className="border  cursor-pointer border-gray-200 px-2 flex items-center gap-1 py-1 rounded-md "
          >
            {" "}
            <GoHome className="relative bottom-[1px] " />
            Home{" "}
          </div>
          <div
            onClick={() => {
              setFormData((p) => ({
                ...p,
                addressLabel: "venue",
              }));
            }}
            style={
              formData.addressLabel === "venue"
                ? {
                    backgroundColor: "#F0F5FE",
                    borderColor: "#a3c1fe",
                    color: "#2136d4",
                    fontWeight: 500,
                  }
                : { opacity: 0.7 }
            }
            className="border cursor-pointer border-gray-200 px-2 flex items-center gap-1 py-1 rounded-md "
          >
            {" "}
            <CiLocationArrow1 className="relative bottom-[1px] " />
            Venue{" "}
          </div>{" "}
          <div
            onClick={() => {
              setFormData((p) => ({
                ...p,
                addressLabel: "work",
              }));
            }}
            style={
              formData.addressLabel === "work"
                ? {
                    backgroundColor: "#F0F5FE",
                    borderColor: "#a3c1fe",
                    color: "#2136d4",
                    fontWeight: 500,
                  }
                : { opacity: 0.7 }
            }
            className="border cursor-pointer border-gray-200 px-2 flex items-center gap-1 py-1 rounded-md "
          >
            {" "}
            <MdOutlineWorkOutline className="relative bottom-[1px] " />
            Work{" "}
          </div>{" "}
          <div
            onClick={() => {
              setFormData((p) => ({
                ...p,
                addressLabel: "",
              }));
            }}
            style={
              isOther
                ? {
                    backgroundColor: "#F0F5FE",
                    borderColor: "#a3c1fe",
                    color: "#2136d4",
                    fontWeight: 500,
                  }
                : {
                    opacity: 0.7,
                  }
            }
            className="border cursor-pointer border-gray-200 px-2 mr-2 flex items-center gap-[2px] py-1 rounded-md "
          >
            {" "}
            <MdOutlineLocationOn className="relative bottom-[.5px] " />
            Other{" "}
          </div>
        </div>
      )}
    </>
  );
}
